import React from 'react';
import { IconWarning } from '@noths/polaris-client-ribbons-design-system';

import { NO_LONGER_AVAILABLE_LABEL } from '../constants/copy';
import * as styles from '../styles/ProductInfo.styles';

export const Suspended = () => (
  <div css={styles.unavailableLabel}>
    <IconWarning css={styles.unavailableLabelIcon} width={24} height={24} />
    {NO_LONGER_AVAILABLE_LABEL}
  </div>
);
